import type { CloudGraphCommitEntityAti } from '@atlassian/search-client/common/types';

export const DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI: CloudGraphCommitEntityAti[] = [
	'ati:cloud:graph:commit',
];
